import type {FC} from 'react';

import type {BreadcrumbItem} from '@/modules/foundation/components/breadcrumb';
import {PortableText} from '@/modules/foundation/sanity/portable-text';
import {
	TextHeading,
	textHeadingPortableTextOverrides,
} from '@/modules/page/components/page-head/text-heading';

import type {TextHeadingFragment} from './query';

interface Props {
	data: TextHeadingFragment;
	breadcrumb?: BreadcrumbItem[];
}

export const TextHeadingContainer: FC<Props> = ({data, breadcrumb}) => {
	const {heading, lead, theme, usePattern, showBreadcrumb} = data;

	return (
		<TextHeading
			heading={heading}
			theme={theme}
			usePattern={usePattern}
			breadcrumb={breadcrumb}
			showBreadcrumb={showBreadcrumb}
		>
			{lead && lead.length > 0 ? (
				<PortableText
					value={lead}
					overrideClassNames={textHeadingPortableTextOverrides}
					theme={theme}
				/>
			) : null}
		</TextHeading>
	);
};
